import { useInfiniteQuery } from "@tanstack/react-query";
import { fetchConsultationSummaries } from "../services/solevaniaService";

export const useUnreviewedSummaries = () => {
  return useInfiniteQuery({
    queryKey: ["summaries"],
    queryFn: fetchConsultationSummaries,
    getNextPageParam: (lastPage) => lastPage.next || undefined,
    initialPageParam: "/api/consulations/summaries/?page=1",
    refetchInterval: 30000,
  });
};
